var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 631,
    viewBox: "0 0 63 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 240.5C75 100.5 26 0.5 19 0H0V631C52.8 631 61.6667 587 59.5 565C54.3333 503.5 47.1 352.5 59.5 240.5Z",
    fill: "#0063A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideLanding);
export default __webpack_public_path__ + "static/media/side-landing.bf0b739cb7525254f114bf8a8f2af50c.svg";
export { ForwardRef as ReactComponent };